import { Components, Theme } from '@mui/material';

export const MuiOutlinedInput: Components<Theme>['MuiOutlinedInput'] = {
  defaultProps: {
    notched: false,
  },
  styleOverrides: {
    root: {
      variants: [
        {
          props: { pilled: true },
          style: {
            borderRadius: '9999px',
          },
        },
      ],
    },
  },
};
